// TODO: this context component should accept a generic type to strictly define the storage object
import React, { Children, ReactElement } from 'react';

import { ServicePromise } from '../../services/services';

import StorageService from '../../services/storage.service';
import AuthService from '../../services/auth.service';

import config from '../../config/config';

export type StorageProps2<T extends keyof any> = {
  children: React.ReactNode[] | React.ReactElement<any, any> | null,
  keys: T //| string[] 
}
export type StorageProps = {
  children: React.ReactNode[] | React.ReactElement<any, any> | null,
  keys: string[] 
}

export const StorageContext = React.createContext<[{ [key: string]: any }, React.Dispatch<React.SetStateAction<{ [key: string]: any }>> | undefined]>([{}, undefined]);

// const Storage = <T=void>({children, keys}: StorageProps<T>): ReactElement => {
const Storage : React.FC<StorageProps> = ({ children, keys }) => {

  const [storageObj, setStorageObj] = React.useState<{ [key: string]: any }>(async () => await keys.reduce(async (obj, k) => ({ ...(await obj), [k]: (await StorageService[config.AUTH_TOKEN_STORAGE_METHOD].retrieve(k)).body }), Promise.resolve({})));
  // const [storageObj, setStorageObj] = React.useState<T>(async () => await Object.keys(keys).reduce(async (obj, k) => (
  //   { ...(await obj), [k]: (await StorageService[config.AUTH_TOKEN_STORAGE_METHOD].retrieve(k)).body }
  // ), Promise.resolve({}) as T) as T);

  React.useEffect(() => {
    (async () => {
      const handleStorageChange = async () => {
        //console.log('storageobj', await keys.reduce(async (obj, k) => ({ ...(await obj), [k]: (await StorageService[config.AUTH_TOKEN_STORAGE_METHOD].retrieve(k)).body }), Promise.resolve({})))
        const newStorage = await keys.reduce(async (obj, k) => ({ ...(await obj), [k]: (await StorageService[config.AUTH_TOKEN_STORAGE_METHOD].retrieve(k)).body }), Promise.resolve({}));
        // console.log('storage update', newStorage)
        setStorageObj(newStorage);
      };

      await handleStorageChange();

      window.addEventListener('storage', handleStorageChange);
      return () => { window.removeEventListener('storage', handleStorageChange) };
    })();
  }, []);

  React.useEffect(() => {
    // not sure why but storage object is sometimes an unresolved promise
    // console.log('pre resolve storage context setting storage to: ', storageObj);
    Promise.resolve(storageObj).then((storageObjResolved) => {
      // console.log('resolved storage context setting storage to: ', storageObjResolved);
      ({
        LOCAL: (() => localStorage.setItem(config.APP_NAME, JSON.stringify(storageObjResolved))),
        SESSION: (() => sessionStorage.setItem(config.APP_NAME, JSON.stringify(storageObjResolved))),
        COOKIE: (() => document.cookie = config.APP_NAME+'='+atob(JSON.stringify(storageObjResolved))), 
        WINDOW: (() => ((window as any)[config.APP_NAME] = storageObjResolved))
      })[config.AUTH_TOKEN_STORAGE_METHOD]();
    });
  }, [storageObj]);

  return (<StorageContext.Provider value={[storageObj, setStorageObj]}>{children}</StorageContext.Provider>);
};

export default Storage;